export default __webpack_public_path__ + "static/fs-icon-270x270-34c9777f27cd24cd17290184c4ddc343.png";